const dealers = [
    { name: 'Barbury Shooting School', position: { lat: 51.4885, lng: -1.774522 }, address: 'Wroughton, Swindon SN4 0QH', hours: 'Mon-Fri: 9.00am-4.30pm, Sat: 9.00am-1.00pm, Sun: 9.00am-1.00pm.', Phone: '01793 940420'  , Website: 'https://www.barburyshootingschool.com/' },
    { name: 'Braces of Bristol', position: { lat: 51.431767, lng: -2.565143 }, address: '427 Wells Rd, Knowle, Bristol BS4 2QW', hours: 'Mon-Fri: 10.00am-5.30pm, Sat: 9.30am-4.30pm, Sun: Closed.', Phone: '01173 009956', Website: 'https://www.bracesofbristol.com/' },
    { name: 'Bushwear Stirling', position: { lat: 56.109102, lng: -3.91568 }, address: '7 Glen Tye Rd, Bushwear, Stirling FK7 7LH', hours: 'Mon: 9.30am-4.00pm, Tues: Closed, Wed-Fri: 9.30am-5.30pm, Sat: 9.00am-4.00pm, Sun: Closed.', Phone: '01786 450404', Website: 'https://www.bushwear.co.uk/' },
    { name: 'Bushwear Perth', position: { lat: 56.42, lng: -3.47 }, address: '5 Inveralmond Rd, Perth PH1 3TW', hours: 'Mon: 9.30am-4.00pm, Tues: Closed, Wed-Fri: 9.30am-5.30pm, Sat: 9.00am-4.00pm, Sun: Closed.', Phone: '01738 508631', Website: 'https://www.bushwear.co.uk/' },
    { name: 'Cadman Sporting Northampton & Rugby', position: { lat: 52.3399, lng: 1.2061 }, address: 'Barby Lane, Warwickshire, CV23 8UX', hours: 'Mon-Tues: 9.00am-5.00pm, Wed: 9.00am-9.00pm, Thurs-Fri: 9.00am-5.30pm, Sat: 9.00am-9.00pm, Sun: Closed.', Phone: '01788 891873', Website: 'https://www.cadmansporting.com/' },
    { name: 'Cadman Sporting Whittlesey', position: { lat: 52.56066, lng: -0.12999 }, address: 'Unit 6 Fenland Industrial Estate, Whittlesey, Peterborough PE7 2EY', hours: 'Mon-Fri: 9.00am-5.00pm, Sat: 9.00am-4.00pm, Sun: Closed.', Phone: '01733 204294', Website: 'https://www.cadmansporting.com/' },
    { name: 'Chris Potter Country Sports', position: { lat: 51.1349067687988, lng: 0.268385797739028 }, address: '2-6 Grover St, Tunbridge Wells TN1 2QB', hours: 'Mon-Tues: 9.00am-5.00pm, Wed: Closed, Thurs-Sat: 9.00am-5.00pm, Sun: Closed.', Phone: '01892 522208', Website: 'https://gun.co.uk/' },
    { name: 'Eastfield Gunroom', position: { lat: 52.75894, lng: -1.936204 }, address: 'Rugeley, Staffordshire', hours: 'Mon-Fri: 9.00am-5.00pm (By Appointment Only).', Phone: '01543 630470', Website: 'https://eastfield.group/' },
    { name: 'Emmett & Stone', position: { lat: 51.586312, lng: -0.741401 }, address: 'Wilton Farm, Marlow Rd, Little Marlow, Marlow SL7 3RR', hours: 'Tues-Sat: 9.00am-5.00pm.', Phone: '01628 474187', Website: 'https://www.emmettandstone.co.uk/' },
    { name: 'Hadfield Guns', position: { lat: 52.802141, lng: -1.061329 }, address: 'Wide Ln, Wymeswold, Loughborough LE12 6SE', hours: 'Mon-Sun: 9.00am-5.00pm.', Phone: '01509 889500', Website: 'https://hadfieldguns.com/' },
    { name: 'Mid Norfolk Shooting Ground', position: { lat: 52.6846618652343, lng: 1.20164310932159 }, address: 'Fakenham Rd, Taverham, Norwich NR8 6HS', hours: 'Tues: 10.00am-4.00pm, Wed: 10am-7.30pm, Thurs-Sat: 10.00am-4.00pm, Sun: Closed.', Phone: '01603 860436', Website: 'https://www.norfolkshooting.co.uk/' },
    { name: 'Oxford Gun Company', position: { lat: 51.804259, lng: -1.085412 }, address: 'Oxford Rd, Oakley, Aylesbury HP18 9RG', hours: 'Mon-Sat: 9.00am-5.30pm, Sun: Closed.', Phone: '01844 238308', Website: 'https://www.oxfordguncompany.co.uk/' },
    { name: 'Perkin Guns', position: { lat: 52.243565, lng: -1.197934 }, address: 'Badby Ln, Daventry NN11 6DE', hours: 'Mon: Closed, Tues-Thurs: 8.30am-5.00pm, Fri-Sat: Closed, Sun: 9.00am-5.00pm.', Phone: '01327 705497', Website: 'https://perkinguns.co.uk/' },
    { name: 'Saddlery & Gunroom', position: { lat: 51.3158493041992, lng: 0.0331168994307518 }, address: '368 Main Rd, Biggin Hill, Westerham TN16 2HN', hours: 'Mon-Sat: 9.00am-5.00pm, Sun: 10.00am-4.00pm.', Phone: '01959 573089', Website: 'https://saddleryandgunroom.co.uk/' },
    { name: 'Shooting Sports UK', position: { lat: 52.694766998291, lng: -2.16772484779357 }, address: 'The Crown Buildings, The Avenue, Stretton, Stafford ST19 9LL', hours: 'Mon-Sat: 9.00am-5.00pm, Sun: Closed.', Phone: '01902 850002', Website: 'https://www.shootingsportsuk.co.uk/' },
    { name: 'Simpson Brothers', position: { lat: 52.596577, lng: -0.448392 }, address: 'Wittering Grange Farm, Peterborough PE8 6NR', hours: 'Mon: Closed, Tues-Sat: 9.00am-5.30pm, Sun: Closed.', Phone: '01832 226376', Website: 'https://simpsonbrothersgunshop.com/' },
    { name: 'Sporting Targets', position: { lat: 52.250831, lng: -0.504294 }, address: 'Knotting Ln, Bedford MK44 1BX', hours: 'Mon-Fri: 8.30am-5.00pm, Sat: 8.30am-6pm, Sun: 8.30am-3.00pm.', Phone: '01234 708893', Website: 'https://www.sportingtargets.co.uk/' },
    { name: 'The Broadway Gunroom', position: { lat: 52.035203, lng: -1.860423 }, address: 'Kennel Ln, Broadway WR12 7DJ', hours: 'Tues-Fri: 9.30am-5.30pm, Sat: 9.00am-5.00pm, Sun: Closed.', Phone: '01386 852519', Website: 'https://thebroadwaygunroom.co.uk/' },
    { name: 'The Gun Room Ivybridge', position: { lat: 50.3854331970214, lng: -3.94115209579467 }, address: 'Endsleigh, Ivybridge PL21 9JL', hours: 'Mon-Sat: 9.00am-5.30pm, Sun: 10.00am-4.00pm.', Phone: '01752 893344', Website: 'https://www.thegunroom.co.uk/' },
    { name: 'William Evans - Bisley', position: { lat: 51.310815, lng: -0.656813 }, address: 'The Old Armoury, Brookwood, Woking GU24 0NY', hours: 'Mon-Sun: 9.00am-5.00pm.', Phone: '01483 486500', Website: 'https://www.williamevans.com/bisley?srsltid=AfmBOoqIOxAJvZ2FHchZRsDCaYzOS8rOlsbWqeeWMuoIZQ3pEZCBOkW1' },
    { name: 'Eastern Sporting', position: { lat: 51.7207, lng: 0.4507 }, address: 'Unit 15 Tattersall Way, Chelmsford CM1 3UB', hours: 'Mon: Closed, Tues-Fri: 8.30am-5.00pm, Sat: 9.00am-5.00pm, Sun: Closed.', Phone: '01245 477600', Website: 'https://easternsporting.com/' },
    { name: 'Chichester Armoury', position: { lat: 50.8368, lng: -0.7836 }, address: '43 West St, Chichester PO19 1RP', hours: 'Mon-Sat: 9.30am-4.00pm, Sun: Closed.', Phone: '01243 774687', Website: 'https://chiarm.co.uk/' },
    { name: 'Park Street Guns', position: { lat: 51.7221, lng: -0.3390 }, address: '1-2 Park St Ln, Park Street, St Albans AL2 2NE', hours: 'Mon-Fri: 8.30am-5.00pm, Sat: 8.30am-1.00pm, Sun: Closed.', Phone: '01727 872646', Website: 'http://www.gunshot.co.uk/' },
    { name: 'Ashford Gun Room', position: { lat: 51.132, lng: 0.817 }, address: 'Unit 8, New Street Farm, Chilmington Green Rd, Ashford TN23 3DL', hours: 'Tue-Fri: 9.00am-5.00pm, Saturday: 8.00am-2.00pm, Sun-Mon: Closed.', Phone: '01233510708', Website: 'http://www.ashfordgunroom.co.uk/' },
    { name: 'Clarkes of Walsham', position: { lat: 52.302, lng: 0.937 }, address: 'The St, Walsham le Willows, Bury St Edmunds IP31 3BA', hours: 'Mon-Fri: 7.30am-5.00pm, Saturday: 8.00am-4.00pm, Sun: Closed.', Phone: '01359259259', Website: 'https://www.clarkesofwalsham.co.uk/' },
    { name: 'Newavon Arms', position: { lat: 51.480, lng: -2.690 }, address: '15 Lodway, Pill, Bristol BS20 0DH', hours: 'Mon-Sat: 10.00am-4.00pm, Sun: Closed.', Phone: '01275372404', Website: 'http://www.newavon-arms.co.uk/' },
    { name: 'Solware Ltd', position: { lat: 52.604, lng: -1.672 }, address: 'Unit 1, Tame Valley Business Centre, Wilnecote, Tamworth B77 5BY', hours: 'Mon-Sat: 9.00am-5.30pm, Sun: Closed.', Phone: '01827215222', Website: 'https://solware.co.uk/' },
    { name: 'Vector Air', position: { lat: 53.202, lng: -0.977 }, address: 'Boughton Industrial Estate, 1 Leen Ct, Newark NG22 9ZD', hours: 'Tue-Sat: 9.30am-4.30pm, Sun-Mon: Closed.', Phone: '07515457525', Website: 'http://www.vector-air.co.uk/' },
    { name: 'Sportarm', position: { lat: 51.547, lng: -0.436 }, address: 'West London Shooting School, Sharvel Ln, W End Rd, Northolt UB5 6RA', hours: 'Mon-Sat: 8.00am-5.00pm, Sun: Closed.', Phone: '02088458849', Website: 'https://www.sportarmwestlondon.com/' },
    { name: 'T Beattie Guns & Ammo', position: { lat: 54.481, lng: -6.759 }, address: '2 Grove Pl, Moygashel, Dungannon BT71 7RU', hours: 'Mon-Wed: 9.00am-6.00pm, Thu: 9.00am-9.00pm, Fri: 9.00am-6.00pm, Sat-Sun: Closed.', Phone: '02887725631', Website: 'https://tbeattiegunsandammo.co.uk/' },
    { name: 'Cluny Country', position: { lat: 56.165, lng: -3.230 }, address: 'Bowhouse Farm, Kinglassie, Lochgelly KY5 0UN', hours: 'Mon-Fri: 9.30am-5.00pm, Saturday: 10.00am-2.00pm, Sun: Closed.', Phone: '01592882600', Website: 'https://clunycountrystore.co.uk/' }
].sort((a, b) => a.name.localeCompare(b.name));

let map;
let infoWindow;
const markers = [];
let dealerList;

async function initMap() {
    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

    dealerList = document.getElementById('dealer-list');
    const findNearbyButton = document.getElementById('find-nearby-dealers');

    // Postcode + geocoder elements
    const postcodeInput = document.getElementById('postcode-input');
    const postcodeSearchButton = document.getElementById('postcode-search');
    const geocoder = new google.maps.Geocoder();

    // NEW: basic mobile detection
    const isMobile = window.innerWidth < 768;

    map = new Map(document.getElementById('map'), {
        center: { lat: 53.5, lng: -1.5 },
        zoom: isMobile ? 5 : 6, // slightly wider view on mobile
        mapId: 'DEMO_MAP_ID',
        gestureHandling: 'greedy'
    });

    infoWindow = new InfoWindow();

    // NEW: bounds for all dealers
    const bounds = new google.maps.LatLngBounds();

    dealers.forEach((dealer, i) => {
        const pin = new PinElement({
            background: '#FF7900',
            glyphColor: 'white',
            borderColor: 'black'
        });
        const marker = new AdvancedMarkerElement({
            position: dealer.position,
            map: map,
            title: `${i + 1}. ${dealer.name}`,
            content: pin.element
        });
        markers.push(marker);

        bounds.extend(dealer.position); // include this dealer in bounds

        marker.addListener('click', () => openInfoWindow(dealer, marker));
    });

    // Fit the map to show all dealers
    map.fitBounds(bounds);

    // Optionally nudge zoom on very small screens so it's not too zoomed in
    if (isMobile && map.getZoom() > 7) {
        map.setZoom(7);
    }

    renderDealerList(dealers);

    // "Near me" button using browser geolocation
    findNearbyButton.addEventListener('click', () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const userLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                dealers.forEach(dealer => {
                    dealer.distance = getDistance(
                        userLocation.lat,
                        userLocation.lng,
                        dealer.position.lat,
                        dealer.position.lng
                    );
                });

                const sortedDealers = dealers.slice().sort((a, b) => a.distance - b.distance);

                renderDealerList(sortedDealers);

                const zoomLevel = isMobile ? 9 : 10;

                map.setCenter(userLocation);
                map.setZoom(zoomLevel);
            }, () => {
                alert('Could not get your location. Please enable location services in your browser settings.');
            });
        } else {
            alert('Geolocation is not supported by your browser.');
        }
    });

    // Postcode search button using Google geocoder
    if (postcodeSearchButton && postcodeInput) {
        postcodeSearchButton.addEventListener('click', () => {
            const postcode = postcodeInput.value.trim();
            if (!postcode) {
                alert('Please enter a postcode');
                return;
            }

            geocoder.geocode(
                { address: postcode, region: 'uk' },
                (results, status) => {
                    if (status === 'OK' && results[0]) {
                        const location = results[0].geometry.location;
                        const userLocation = {
                            lat: location.lat(),
                            lng: location.lng()
                        };

                        // Compute distance from geocoded postcode to each dealer
                        dealers.forEach(dealer => {
                            dealer.distance = getDistance(
                                userLocation.lat,
                                userLocation.lng,
                                dealer.position.lat,
                                dealer.position.lng
                            );
                        });

                        const sortedDealers = dealers
                            .slice()
                            .sort((a, b) => a.distance - b.distance);

                        renderDealerList(sortedDealers);

                        const zoomLevel = isMobile ? 9 : 10;

                        map.setCenter(userLocation);
                        map.setZoom(zoomLevel);
                    } else {
                        alert('Could not find that postcode. Please check it and try again.');
                    }
                }
            );
        });
    }
}

function renderDealerList(dealersToRender) {
    dealerList.innerHTML = '';
    markers.forEach(marker => marker.map = null);

    if (dealersToRender.length === 0) {
        dealerList.innerHTML = '<p>No dealers found.</p>';
        return;
    }

    dealersToRender.forEach(dealer => {
        const originalIndex = dealers.findIndex(d => d.name === dealer.name);
        if (originalIndex !== -1) {
            markers[originalIndex].map = map;
        }

        const listItem = document.createElement('div');
        listItem.className = 'dealer-item';
        
        let distanceHTML = '';
        if (dealer.distance) {
            distanceHTML = `<p class="distance">${dealer.distance.toFixed(2)} km away</p>`;
        }

        listItem.innerHTML = `
            <h3>${dealer.name}</h3>
            <p>${dealer.address}</p>
            ${distanceHTML}
        `;
        listItem.addEventListener('click', () => {
            openInfoWindow(dealer, markers[originalIndex]);
            map.setCenter(dealer.position);
            map.setZoom(14);
        });
        dealerList.appendChild(listItem);
    });
}

function openInfoWindow(dealer, marker) {
    if (infoWindow) {
        infoWindow.close();
    }

    const phoneLine = dealer.Phone
        ? `<p><b>Phone:</b> <a href="tel:${dealer.Phone.replace(/\s+/g, '')}">${dealer.Phone}</a></p>`
        : '';

    const websiteLine = dealer.Website
        ? `<p><a href="${dealer.Website}" target="_blank" rel="noopener noreferrer">Visit website</a></p>`
        : '';

    const content = `
        <div>
            <h3>${dealer.name}</h3>
            <p>${dealer.address}</p>
            ${phoneLine}
            <p><b>Hours:</b> ${dealer.hours}</p>
            <p>
              <a href="https://www.google.com/maps/dir/?api=1&destination=${dealer.position.lat},${dealer.position.lng}" target="_blank" rel="noopener noreferrer">
                Get Directions
              </a>
            </p>
            ${websiteLine}
        </div>
    `;

    infoWindow.setContent(content);
    infoWindow.open(map, marker);
}


function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a = 
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

// Expose initMap so Google Maps can call it
window.initMap = initMap;
